"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint object-property-newline: "off" */
var _default = [{
  value: 'AF',
  label: 'Afghanistan',
  provinces: []
}, {
  value: 'AL',
  label: 'Albania',
  provinces: []
}, {
  value: 'DZ',
  label: 'Algeria',
  provinces: []
}, {
  value: 'AS',
  label: 'American Samoa',
  provinces: []
}, {
  value: 'AD',
  label: 'Andorra',
  provinces: []
}, {
  value: 'AO',
  label: 'Angola',
  provinces: []
}, {
  value: 'AI',
  label: 'Anguilla',
  provinces: []
}, {
  value: 'AQ',
  label: 'Antarctica',
  provinces: []
}, {
  value: 'AG',
  label: 'Antigua and Barbuda',
  provinces: []
}, {
  value: 'AR',
  label: 'Argentina',
  provinces: []
}, {
  value: 'AM',
  label: 'Armenia',
  provinces: []
}, {
  value: 'AW',
  label: 'Aruba',
  provinces: []
}, {
  value: 'AC',
  label: 'Ascension Island',
  provinces: []
}, {
  value: 'AU',
  label: 'Australia',
  provinces: []
}, {
  value: 'AT',
  label: 'Austria',
  provinces: []
}, {
  value: 'AZ',
  label: 'Azerbaijan',
  provinces: []
}, {
  value: 'BS',
  label: 'Bahamas',
  provinces: []
}, {
  value: 'BH',
  label: 'Bahrain',
  provinces: []
}, {
  value: 'BD',
  label: 'Bangladesh',
  provinces: []
}, {
  value: 'BB',
  label: 'Barbados',
  provinces: []
}, {
  value: 'BY',
  label: 'Belarus',
  provinces: []
}, {
  value: 'BE',
  label: 'Belgium',
  provinces: []
}, {
  value: 'BZ',
  label: 'Belize',
  provinces: []
}, {
  value: 'BJ',
  label: 'Benin',
  provinces: []
}, {
  value: 'BM',
  label: 'Bermuda',
  provinces: []
}, {
  value: 'BT',
  label: 'Bhutan',
  provinces: []
}, {
  value: 'BO',
  label: 'Bolivia',
  provinces: []
}, {
  value: 'BA',
  label: 'Bosnia',
  provinces: []
}, {
  value: 'BW',
  label: 'Botswana',
  provinces: []
}, {
  value: 'BV',
  label: 'Bouvet Island',
  provinces: []
}, {
  value: 'BR',
  label: 'Brazil',
  provinces: []
}, {
  value: 'BN',
  label: 'Brunei Darussalam',
  provinces: []
}, {
  value: 'BG',
  label: 'Bulgaria',
  provinces: []
}, {
  value: 'BF',
  label: 'Burkina Faso',
  provinces: []
}, {
  value: 'BI',
  label: 'Burundi',
  provinces: []
}, {
  value: 'KH',
  label: 'Cambodia',
  provinces: []
}, {
  value: 'CM',
  label: 'Cameroon',
  provinces: []
}, {
  value: 'CA',
  label: 'Canada',
  provinces: [{
    value: 'AB',
    label: 'Alberta'
  }, {
    value: 'BC',
    label: 'British Columbia'
  }, {
    value: 'MB',
    label: 'Manitoba'
  }, {
    value: 'NB',
    label: 'New Brunswick'
  }, {
    value: 'NL',
    label: 'Newfoundland and Labrador'
  }, {
    value: 'NT',
    label: 'Northwest Territories'
  }, {
    value: 'NS',
    label: 'Nova Scotia'
  }, {
    value: 'NU',
    label: 'Nunavut'
  }, {
    value: 'ON',
    label: 'Ontario'
  }, {
    value: 'PE',
    label: 'Prince Edward Island'
  }, {
    value: 'QC',
    label: 'Quebec'
  }, {
    value: 'SK',
    label: 'Saskatchewan'
  }, {
    value: 'YT',
    label: 'Yukon'
  }]
}, {
  value: 'CV',
  label: 'Cape Verde',
  provinces: []
}, {
  value: 'KY',
  label: 'Cayman Islands',
  provinces: []
}, {
  value: 'CF',
  label: 'Central African Rep.',
  provinces: []
}, {
  value: 'TD',
  label: 'Chad',
  provinces: []
}, {
  value: 'CL',
  label: 'Chile',
  provinces: []
}, {
  value: 'CN',
  label: 'China',
  provinces: []
}, {
  value: 'CX',
  label: 'Christmas Island',
  provinces: []
}, {
  value: 'CO',
  label: 'Colombia',
  provinces: []
}, {
  value: 'KM',
  label: 'Comoros',
  provinces: []
}, {
  value: 'CG',
  label: 'Congo, Republic of',
  provinces: []
}, {
  value: 'CK',
  label: 'Cook Islands',
  provinces: []
}, {
  value: 'CR',
  label: 'Costa Rica',
  provinces: []
}, {
  value: 'CI',
  label: 'Cote deIvoire',
  provinces: []
}, {
  value: 'HR',
  label: 'Croatia',
  provinces: []
}, {
  value: 'CU',
  label: 'Cuba',
  provinces: []
}, {
  value: 'CY',
  label: 'Cyprus',
  provinces: []
}, {
  value: 'CZ',
  label: 'Czech Republic',
  provinces: []
}, {
  value: 'DK',
  label: 'Denmark',
  provinces: []
}, {
  value: 'DJ',
  label: 'Djibouti',
  provinces: []
}, {
  value: 'DM',
  label: 'Dominica',
  provinces: []
}, {
  value: 'DO',
  label: 'Dominican Republic',
  provinces: []
}, {
  value: 'TP',
  label: 'East Timor',
  provinces: []
}, {
  value: 'EC',
  label: 'Ecuador',
  provinces: []
}, {
  value: 'EG',
  label: 'Egypt',
  provinces: []
}, {
  value: 'SV',
  label: 'El Salvador',
  provinces: []
}, {
  value: 'GQ',
  label: 'Equatorial Guinea',
  provinces: []
}, {
  value: 'ER',
  label: 'Eritrea',
  provinces: []
}, {
  value: 'EE',
  label: 'Estonia',
  provinces: []
}, {
  value: 'ET',
  label: 'Ethiopia',
  provinces: []
}, {
  value: 'FK',
  label: 'Falkland Islands',
  provinces: []
}, {
  value: 'FO',
  label: 'Faroe Islands',
  provinces: []
}, {
  value: 'FJ',
  label: 'Fiji',
  provinces: []
}, {
  value: 'FI',
  label: 'Finland',
  provinces: []
}, {
  value: 'FR',
  label: 'France',
  provinces: []
}, {
  value: 'GF',
  label: 'French Guiana',
  provinces: []
}, {
  value: 'PF',
  label: 'French Polynesia',
  provinces: []
}, {
  value: 'GA',
  label: 'Gabon',
  provinces: []
}, {
  value: 'GM',
  label: 'Gambia',
  provinces: []
}, {
  value: 'GE',
  label: 'Georgia',
  provinces: []
}, {
  value: 'DE',
  label: 'Germany',
  provinces: []
}, {
  value: 'GH',
  label: 'Ghana',
  provinces: []
}, {
  value: 'GI',
  label: 'Gibraltar',
  provinces: []
}, {
  value: 'GR',
  label: 'Greece',
  provinces: []
}, {
  value: 'GL',
  label: 'Greenland',
  provinces: []
}, {
  value: 'GD',
  label: 'Grenada',
  provinces: []
}, {
  value: 'GP',
  label: 'Guadeloupe',
  provinces: []
}, {
  value: 'GU',
  label: 'Guam',
  provinces: []
}, {
  value: 'GT',
  label: 'Guatemala',
  provinces: []
}, {
  value: 'GG',
  label: 'Guernsey',
  provinces: []
}, {
  value: 'GN',
  label: 'Guinea',
  provinces: []
}, {
  value: 'GY',
  label: 'Guyana',
  provinces: []
}, {
  value: 'HT',
  label: 'Haiti',
  provinces: []
}, {
  value: 'HN',
  label: 'Honduras',
  provinces: []
}, {
  value: 'HK',
  label: 'Hong Kong',
  provinces: []
}, {
  value: 'HU',
  label: 'Hungary',
  provinces: []
}, {
  value: 'IS',
  label: 'Iceland',
  provinces: []
}, {
  value: 'IN',
  label: 'India',
  provinces: []
}, {
  value: 'ID',
  label: 'Indonesia',
  provinces: []
}, {
  value: 'IR',
  label: 'Iran',
  provinces: []
}, {
  value: 'IQ',
  label: 'Iraq',
  provinces: []
}, {
  value: 'IE',
  label: 'Ireland',
  provinces: []
}, {
  value: 'IM',
  label: 'Isle of Man',
  provinces: []
}, {
  value: 'IL',
  label: 'Israel',
  provinces: []
}, {
  value: 'IT',
  label: 'Italy',
  provinces: []
}, {
  value: 'JM',
  label: 'Jamaica',
  provinces: []
}, {
  value: 'JP',
  label: 'Japan',
  provinces: []
}, {
  value: 'JE',
  label: 'Jersey',
  provinces: []
}, {
  value: 'JO',
  label: 'Jordan',
  provinces: []
}, {
  value: 'KZ',
  label: 'Kazakhstan',
  provinces: []
}, {
  value: 'KE',
  label: 'Kenya',
  provinces: []
}, {
  value: 'KI',
  label: 'Kiribati',
  provinces: []
}, {
  value: 'KP',
  label: 'Korea, North',
  provinces: []
}, {
  value: 'KR',
  label: 'Korea, South',
  provinces: []
}, {
  value: 'KW',
  label: 'Kuwait',
  provinces: []
}, {
  value: 'KG',
  label: 'Kyrgyzstan',
  provinces: []
}, {
  value: 'LA',
  label: 'Lao PDR',
  provinces: []
}, {
  value: 'LV',
  label: 'Latvia',
  provinces: []
}, {
  value: 'LB',
  label: 'Lebanon',
  provinces: []
}, {
  value: 'LS',
  label: 'Lesotho',
  provinces: []
}, {
  value: 'LR',
  label: 'Liberia',
  provinces: []
}, {
  value: 'LY',
  label: 'Libya',
  provinces: []
}, {
  value: 'LI',
  label: 'Liechtenstein',
  provinces: []
}, {
  value: 'LT',
  label: 'Lithuania',
  provinces: []
}, {
  value: 'LU',
  label: 'Luxembourg',
  provinces: []
}, {
  value: 'MO',
  label: 'Macau',
  provinces: []
}, {
  value: 'MK',
  label: 'Macedonia',
  provinces: []
}, {
  value: 'MG',
  label: 'Madagascar',
  provinces: []
}, {
  value: 'MW',
  label: 'Malawi',
  provinces: []
}, {
  value: 'MY',
  label: 'Malaysia',
  provinces: []
}, {
  value: 'MV',
  label: 'Maldives',
  provinces: []
}, {
  value: 'ML',
  label: 'Mali',
  provinces: []
}, {
  value: 'MT',
  label: 'Malta',
  provinces: []
}, {
  value: 'MH',
  label: 'Marshall Islands',
  provinces: []
}, {
  value: 'MQ',
  label: 'Martinique',
  provinces: []
}, {
  value: 'MR',
  label: 'Mauritania',
  provinces: []
}, {
  value: 'MU',
  label: 'Mauritius',
  provinces: []
}, {
  value: 'YT',
  label: 'Mayotte',
  provinces: []
}, {
  value: 'MX',
  label: 'Mexico',
  provinces: [{
    value: 'AG',
    label: 'Aguascalientes'
  }, {
    value: 'BC',
    label: 'Baja California Norte '
  }, {
    value: 'BS',
    label: 'Baja California Sur'
  }, {
    value: 'CH',
    label: 'Chihuahua'
  }, {
    value: 'CL',
    label: 'Colima'
  }, {
    value: 'CM',
    label: 'Campeche'
  }, {
    value: 'CO',
    label: 'Coahuila'
  }, {
    value: 'CS',
    label: 'Chiapas'
  }, {
    value: 'DF',
    label: 'Distrito Federal'
  }, {
    value: 'DG',
    label: 'Durango'
  }, {
    value: 'GR',
    label: 'Guerrero'
  }, {
    value: 'GT',
    label: 'Guanajuato'
  }, {
    value: 'HG',
    label: 'Hidalgo'
  }, {
    value: 'JA',
    label: 'Jalisco'
  }, {
    value: 'MI',
    label: 'Michoacan'
  }, {
    value: 'MO',
    label: 'Morelos'
  }, {
    value: 'NA',
    label: 'Nayarit'
  }, {
    value: 'NL',
    label: 'Nuevo Leon'
  }, {
    value: 'OA',
    label: 'Oaxaca'
  }, {
    value: 'PU',
    label: 'Puebla'
  }, {
    value: 'QR',
    label: 'Quintana Roo'
  }, {
    value: 'QT',
    label: 'Queretaro'
  }, {
    value: 'SI',
    label: 'Sinaloa'
  }, {
    value: 'SL',
    label: 'San Luis Potosi'
  }, {
    value: 'SO',
    label: 'Sonora'
  }, {
    value: 'TB',
    label: 'Tabasco'
  }, {
    value: 'TL',
    label: 'Tlaxcala'
  }, {
    value: 'TM',
    label: 'Tamaulipas'
  }, {
    value: 'VE',
    label: 'Veracruz'
  }, {
    value: 'YU',
    label: 'Yucatan'
  }, {
    value: 'ZA',
    label: 'Zacatecas'
  }]
}, {
  value: 'FM',
  label: 'Micronesia',
  provinces: []
}, {
  value: 'MD',
  label: 'Moldova',
  provinces: []
}, {
  value: 'MC',
  label: 'Monaco',
  provinces: []
}, {
  value: 'MN',
  label: 'Mongolia',
  provinces: []
}, {
  value: 'MS',
  label: 'Montserrat',
  provinces: []
}, {
  value: 'MA',
  label: 'Morocco',
  provinces: []
}, {
  value: 'MZ',
  label: 'Mozambique',
  provinces: []
}, {
  value: 'MM',
  label: 'Myanmar',
  provinces: []
}, {
  value: 'NA',
  label: 'Namibia',
  provinces: []
}, {
  value: 'NR',
  label: 'Nauru',
  provinces: []
}, {
  value: 'NP',
  label: 'Nepal',
  provinces: []
}, {
  value: 'NL',
  label: 'Netherlands',
  provinces: []
}, {
  value: 'AN',
  label: 'Netherlands Ant.',
  provinces: []
}, {
  value: 'NC',
  label: 'New Caledonia',
  provinces: []
}, {
  value: 'NZ',
  label: 'New Zealand',
  provinces: []
}, {
  value: 'NI',
  label: 'Nicaragua',
  provinces: []
}, {
  value: 'NE',
  label: 'Niger',
  provinces: []
}, {
  value: 'NG',
  label: 'Nigeria',
  provinces: []
}, {
  value: 'NU',
  label: 'Niue',
  provinces: []
}, {
  value: 'NF',
  label: 'Norfolk Island',
  provinces: []
}, {
  value: 'NO',
  label: 'Norway',
  provinces: []
}, {
  value: 'OM',
  label: 'Oman',
  provinces: []
}, {
  value: 'PK',
  label: 'Pakistan',
  provinces: []
}, {
  value: 'PW',
  label: 'Palau',
  provinces: []
}, {
  value: 'PS',
  label: 'Palestine',
  provinces: []
}, {
  value: 'PA',
  label: 'Panama',
  provinces: []
}, {
  value: 'PG',
  label: 'Papua New Guinea',
  provinces: []
}, {
  value: 'PY',
  label: 'Paraguay',
  provinces: []
}, {
  value: 'PE',
  label: 'Peru',
  provinces: []
}, {
  value: 'PH',
  label: 'Philippines',
  provinces: []
}, {
  value: 'PN',
  label: 'Pitcairn',
  provinces: []
}, {
  value: 'PL',
  label: 'Poland',
  provinces: []
}, {
  value: 'PT',
  label: 'Portugal',
  provinces: []
}, {
  value: 'PR',
  label: 'Puerto Rico',
  provinces: []
}, {
  value: 'QA',
  label: 'Qatar',
  provinces: []
}, {
  value: 'RE',
  label: 'Reunion',
  provinces: []
}, {
  value: 'RO',
  label: 'Romania',
  provinces: []
}, {
  value: 'RU',
  label: 'Russia',
  provinces: []
}, {
  value: 'RW',
  label: 'Rwanda',
  provinces: []
}, {
  value: 'KN',
  label: 'Saint Kitts',
  provinces: []
}, {
  value: 'LC',
  label: 'Saint Lucia',
  provinces: []
}, {
  value: 'VC',
  label: 'Saint Vincent',
  provinces: []
}, {
  value: 'WS',
  label: 'Samoa',
  provinces: []
}, {
  value: 'SM',
  label: 'San Marino',
  provinces: []
}, {
  value: 'ST',
  label: 'Sao Tome',
  provinces: []
}, {
  value: 'SA',
  label: 'Saudi Arabia',
  provinces: []
}, {
  value: 'SN',
  label: 'Senegal',
  provinces: []
}, {
  value: 'YU',
  label: 'Serbia and Montenegro',
  provinces: []
}, {
  value: 'SC',
  label: 'Seychelles',
  provinces: []
}, {
  value: 'SL',
  label: 'Sierra Leone',
  provinces: []
}, {
  value: 'SG',
  label: 'Singapore',
  provinces: []
}, {
  value: 'SK',
  label: 'Slovakia',
  provinces: []
}, {
  value: 'SI',
  label: 'Slovenia',
  provinces: []
}, {
  value: 'SB',
  label: 'Solomon Islands',
  provinces: []
}, {
  value: 'SO',
  label: 'Somalia',
  provinces: []
}, {
  value: 'ZA',
  label: 'South Africa',
  provinces: []
}, {
  value: 'GS',
  label: 'South Georgia',
  provinces: []
}, {
  value: 'ES',
  label: 'Spain',
  provinces: []
}, {
  value: 'LK',
  label: 'Sri Lanka',
  provinces: []
}, {
  value: 'SH',
  label: 'St. Helena',
  provinces: []
}, {
  value: 'SD',
  label: 'Sudan',
  provinces: []
}, {
  value: 'SR',
  label: 'Surinam',
  provinces: []
}, {
  value: 'SZ',
  label: 'Swaziland',
  provinces: []
}, {
  value: 'SE',
  label: 'Sweden',
  provinces: []
}, {
  value: 'CH',
  label: 'Switzerland',
  provinces: []
}, {
  value: 'SY',
  label: 'Syrian Arab Republic',
  provinces: []
}, {
  value: 'TW',
  label: 'Taiwan',
  provinces: []
}, {
  value: 'TJ',
  label: 'Tajikistan',
  provinces: []
}, {
  value: 'TZ',
  label: 'Tanzania',
  provinces: []
}, {
  value: 'TH',
  label: 'Thailand',
  provinces: []
}, {
  value: 'TG',
  label: 'Togo',
  provinces: []
}, {
  value: 'TK',
  label: 'Tokelau',
  provinces: []
}, {
  value: 'TO',
  label: 'Tonga',
  provinces: []
}, {
  value: 'TT',
  label: 'Trinidad and Tobago',
  provinces: []
}, {
  value: 'TN',
  label: 'Tunisia',
  provinces: []
}, {
  value: 'TR',
  label: 'Turkey',
  provinces: []
}, {
  value: 'TM',
  label: 'Turkmenistan',
  provinces: []
}, {
  value: 'TV',
  label: 'Tuvalu',
  provinces: []
}, {
  value: 'UG',
  label: 'Uganda',
  provinces: []
}, {
  value: 'UA',
  label: 'Ukraine',
  provinces: []
}, {
  value: 'AE',
  label: 'United Arab Emirates',
  provinces: []
}, {
  value: 'GB',
  label: 'United Kingdom',
  provinces: []
}, {
  value: 'US',
  label: 'United States',
  provinces: [{
    label: 'Armed Forces',
    value: 'AE'
  }, {
    label: 'Armed Forces Pacific',
    value: 'AP'
  }, {
    label: 'Armed Forces America',
    value: 'AA'
  }, {
    label: 'Alabama',
    value: 'AL'
  }, {
    label: 'Alaska',
    value: 'AK'
  }, {
    label: 'American Samoa',
    value: 'AS'
  }, {
    label: 'Arizona',
    value: 'AZ'
  }, {
    label: 'Arkansas',
    value: 'AR'
  }, {
    label: 'California',
    value: 'CA'
  }, {
    label: 'Colorado',
    value: 'CO'
  }, {
    label: 'Connecticut',
    value: 'CT'
  }, {
    label: 'Delaware',
    value: 'DE'
  }, {
    label: 'District Of Columbia',
    value: 'DC'
  }, {
    label: 'Federated States Of Micronesia',
    value: 'FM'
  }, {
    label: 'Florida',
    value: 'FL'
  }, {
    label: 'Georgia',
    value: 'GA'
  }, {
    label: 'Guam',
    value: 'GU'
  }, {
    label: 'Hawaii',
    value: 'HI'
  }, {
    label: 'Idaho',
    value: 'ID'
  }, {
    label: 'Illinois',
    value: 'IL'
  }, {
    label: 'Indiana',
    value: 'IN'
  }, {
    label: 'Iowa',
    value: 'IA'
  }, {
    label: 'Kansas',
    value: 'KS'
  }, {
    label: 'Kentucky',
    value: 'KY'
  }, {
    label: 'Louisiana',
    value: 'LA'
  }, {
    label: 'Maine',
    value: 'ME'
  }, {
    label: 'Marshall Islands',
    value: 'MH'
  }, {
    label: 'Maryland',
    value: 'MD'
  }, {
    label: 'Massachusetts',
    value: 'MA'
  }, {
    label: 'Michigan',
    value: 'MI'
  }, {
    label: 'Minnesota',
    value: 'MN'
  }, {
    label: 'Mississippi',
    value: 'MS'
  }, {
    label: 'Missouri',
    value: 'MO'
  }, {
    label: 'Montana',
    value: 'MT'
  }, {
    label: 'Nebraska',
    value: 'NE'
  }, {
    label: 'Nevada',
    value: 'NV'
  }, {
    label: 'New Hampshire',
    value: 'NH'
  }, {
    label: 'New Jersey',
    value: 'NJ'
  }, {
    label: 'New Mexico',
    value: 'NM'
  }, {
    label: 'New York',
    value: 'NY'
  }, {
    label: 'North Carolina',
    value: 'NC'
  }, {
    label: 'North Dakota',
    value: 'ND'
  }, {
    label: 'Northern Mariana Islands',
    value: 'MP'
  }, {
    label: 'Ohio',
    value: 'OH'
  }, {
    label: 'Oklahoma',
    value: 'OK'
  }, {
    label: 'Oregon',
    value: 'OR'
  }, {
    label: 'Palau',
    value: 'PW'
  }, {
    label: 'Pennsylvania',
    value: 'PA'
  }, {
    label: 'Puerto Rico',
    value: 'PR'
  }, {
    label: 'Rhode Island',
    value: 'RI'
  }, {
    label: 'South Carolina',
    value: 'SC'
  }, {
    label: 'South Dakota',
    value: 'SD'
  }, {
    label: 'Tennessee',
    value: 'TN'
  }, {
    label: 'Texas',
    value: 'TX'
  }, {
    label: 'Utah',
    value: 'UT'
  }, {
    label: 'Vermont',
    value: 'VT'
  }, {
    label: 'Virgin Islands',
    value: 'VI'
  }, {
    label: 'Virginia',
    value: 'VA'
  }, {
    label: 'Washington',
    value: 'WA'
  }, {
    label: 'West Virginia',
    value: 'WV'
  }, {
    label: 'Wisconsin',
    value: 'WI'
  }, {
    label: 'Wyoming',
    value: 'WY'
  }]
}, {
  value: 'UY',
  label: 'Uruguay',
  provinces: []
}, {
  value: 'UZ',
  label: 'Uzbekistan',
  provinces: []
}, {
  value: 'VU',
  label: 'Vanuatu',
  provinces: []
}, {
  value: 'VE',
  label: 'Venezuela',
  provinces: []
}, {
  value: 'VN',
  label: 'Vietnam',
  provinces: []
}, {
  value: 'VG',
  label: 'British Virgin Islands',
  provinces: []
}, {
  value: 'VI',
  label: 'US Virgin Islands',
  provinces: []
}, {
  value: 'EH',
  label: 'Western Sahara',
  provinces: []
}, {
  value: 'YE',
  label: 'Yemen',
  provinces: []
}, {
  value: 'ZM',
  label: 'Zambia',
  provinces: []
}, {
  value: 'ZW',
  label: 'Zimbabwe',
  provinces: []
}];
exports.default = _default;